import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import useEmbedTheme from "../../Hooks/useEmbedTheme";

const ConsultationFormEmbedRedirect = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const theme = useEmbedTheme();

  const guestClient = new URLSearchParams(location.search).get("client");
  const clientParam = guestClient ? `?client=${encodeURIComponent(guestClient)}` : "";

  useEffect(() => {
    const cp = new URLSearchParams(location.search).get("client");
    const param = cp ? `?client=${encodeURIComponent(cp)}` : "";
    const timer = setTimeout(() => {
      if (!id) {
        navigate(`/embed/consultation/form${param}`);
      } else {
        navigate(`/embed/consultation/${id}${param}`);
      }
    }, 5000);
    return () => {
      clearTimeout(timer);
    };
  }, [id, navigate, location.search]);

  function handleSkip() {
    if (!id) {
      navigate(`/embed/consultation/form${clientParam}`);
    } else {
      navigate(`/embed/consultation/${id}${clientParam}`);
    }
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: theme.background }}
    >
      <div className="bg-white p-8 space-y-4 rounded-lg shadow-sm text-center max-w-md w-full">
        <div>
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <div className="mt-3 sm:mt-5">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {t("Consultation Request Confirmed")}
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                {t("Redirecting you to your consultation page shortly.")}
              </p>
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-6">
          <button
            type="button"
            onClick={handleSkip}
            className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
            style={{
              backgroundColor: theme.primary,
              color: theme.primaryText,
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = theme.primaryHover; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = theme.primary; }}
          >
            {t("View Consultation")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsultationFormEmbedRedirect;
